import { MasterVisualizarUsuarioComponent } from './../visualizar-usuario/master-visualizar-usuario.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MasterConsultaUsuariosService } from './master-cliente-consulta-usuarios.service';
import { User } from './master-cliente-consulta-usuarios.model';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { MasterClienteCreateUserComponent } from '../master-cliente/cliente-criar-usuario-stepper/master-cliente-create-user.component';

import { MasterClienteVisualizarUsuarioComponent } from '../master-cliente/cliente-visualizar-usuario/cliente-visualizar-usuario.component';
import { PermissionsType } from '../../../custom-shared/enums/permissions-type.enum';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-master-cliente-consulta-usuarios',
  templateUrl: './master-cliente-consulta-usuarios.component.html',
  styleUrls: ['./master-cliente-consulta-usuarios.component.scss'],
})
export class MasterClienteConsultaUsuarios extends AppScreenBase
  implements OnInit {
  protected onClose(): void { }

  users: any;
  userFilter: any;
  displayedColumns: string[] = [
    'name',
    'userSso',
    'login',
    'profile',
    'status',
    'actions',
  ];
  sorted: boolean = false;
  filterAutoComplete: Array<any>;
  usersComplete: any;
  optionUsersComplete: any;
  cadastrar: boolean;
  editar: boolean;

  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;

  constructor(
    private _MasterConsultaUsuariosService: MasterConsultaUsuariosService,
    public dialog: MatDialog,
    private custonAutenticationServise: CustomAuthenticationService,
  ) {
    super();
  }

  ngOnInit() {
    this.getUsers();
    this.cadastrar = this.custonAutenticationServise.hasPermission(
      PermissionsType.cadastrarUsuarios,
    );
    this.editar = this.custonAutenticationServise.hasPermission(
      PermissionsType.editarUsuarios,
    );

  }

  async getUsers() {
    const result = await this._MasterConsultaUsuariosService.getUsers();

    result.map(u => u.qtd);
    this.users = new MatTableDataSource<User>(
      result.sort((a, b) => {
        if (a.userSso == null) {
          a.userSso = ''
        }
        if (b.userSso == null) {
          b.userSso = ''
        }
        if (a.name === null) {
          a.name = '';
        }
        if (b.name === null) {
          b.name = '';
        }
        return a.name
          .toLowerCase()
          .normalize('NFD')
          .replace(/[^a-zA-Z0-9s]/g, '') >
          b.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[^a-zA-Z0-9s]/g, '')
          ? 1
          : -1;
      }),
    );


    this.users.sortingDataAccessor = (data, sortHeaderId) =>
      typeof data[sortHeaderId] === 'string'
        ? data[sortHeaderId]
          .normalize('NFD')
          .replace(/[^a-zA-Z0-9s]/g, '')
          .toLowerCase()
        : data[sortHeaderId].name
          .normalize('NFD')
          .replace(/[^a-zA-Z0-9s]/g, '')
          .toLowerCase();

    this.users.sort = this.sortUsers;
    if (this.userFilter != null) {
      this.users.filter = this.userFilter
    }
    this.sortUsers.disableClear = true;
  }

  filterUsers(event: Event) {
    this.users.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.naturalNormalize().includes(filter.naturalNormalize());
    };
    this.userFilter = (event.target as HTMLInputElement).value;
    this.users.filter = this.userFilter;

    this.optionUsersComplete = this.users.filteredData;

    if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {
      this.usersComplete = this.users.filteredData;
    } else if (this.userFilter.length == 0) {
      this.usersComplete = [];
      this.optionUsersComplete = [];
    }
  }

  openDialogCreateUser() {
    this.dialog
      .open(MasterClienteCreateUserComponent, this.dialogConfig)
      .afterClosed()
      .toPromise()
      .then(_ => {
        this.getUsers();

      });
  }

  openDialogVisualizarUsuario(id) {
    const dialogRef = this.dialog.open(
      MasterClienteVisualizarUsuarioComponent,
      this.dialogConfig,
    );
    dialogRef.componentInstance.id = id;
    dialogRef
      .afterClosed()
      .toPromise()
      .then(_ => {
        this.getUsers();
      });
  }
}
